import { render, staticRenderFns } from "./PlayerStepsMain.vue?vue&type=template&id=0e8d7e0c&scoped=true&"
import script from "./PlayerStepsMain.vue?vue&type=script&lang=js&"
export * from "./PlayerStepsMain.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStepsMain.vue?vue&type=style&index=0&id=0e8d7e0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d7e0c",
  null
  
)

export default component.exports